import sh from "bundles/common/utils/sh";

export default function exportCsv(model, ids, authenticityToken, columns) {
  return sh
    .post(
      "/internal/search/csv_export",
      {
        model,
        ids,
        columns: JSON.stringify(columns),
        authenticity_token: authenticityToken,
      },
      { responseType: "blob" }
    )
    .then((res) => {
      const disposition = res.headers["content-disposition"] || "";
      const match = disposition.match(/filename="?([^";\s]+)"?/);
      const filename = match ? match[1] : `${model}_${new Date().toISOString().slice(0, 10)}.csv`;

      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    });
}
